import { LitElement, html, css } from 'lit'
import { unsafeHTML } from 'lit/directives/unsafe-html.js'
import './list'

customElements.define('k-review', class extends LitElement{

    static styles = css`
        :host {
            display: block;
            position:relative;
        }

        img {
            clip-path: polygon(10% 0%, 100% 0%, 90% 100%, 0% 100%);
        }

        .quote {
            font-style: italic;
            font-size: 1.2em;
            font-weight: bold;
            background: var(--orange-muted);
            padding: 1em;
        }
    `

    constructor(){
        super()
        this.data = window.reviewData || {}
    }

    render(){return html`
        
        <b-grid cols="auto,1" cols-mobile="1" gap=2>

            <k-image>${unsafeHTML(this.data.imgs.medium)}</k-image>

            <b-grid cols="1" cols-mobile="1" gap=2>

                <b-grid cols=1 gap=".5">
                    <k-h1>${this.data.name}</k-h1>

                    <k-h4>
                        ${this.data.date}

                        ${this.data.trip?html`
                            - <b-text href=${this.data.trip.link}>${this.data.trip.post_title}</b-text>    
                        `:''}
                    </k-h4>
                    
                    
                </b-grid>

                ${this.data.pull_quote?html`
                    <b-text class="quote" pretty .html=${this.data.pull_quote}></b-text>
                `:''}

                <b-text body italic .html=${this.data.content}></b-text>

                ${this.data.social?html`
                    <b-text align="center">
                        <b-btn href=${this.data.social} text color="theme">View ${this.data.name}'s profile</b-btn>
                    </b-text>
                `:''}
            </b-grid>

        </b-grid>
    `}

})

export default customElements.get('k-review')